/**
 * Herkunft: wo der Nutzer herkam, auf dem Weg zum Kontakt mitgefuehrt.
 *
 * Ein Kontakt gehoert immer zu einem Kunden oder einem Partner. Beim Rueckweg
 * ist aber nicht die Frage, wohin er gehoert, sondern wo der Mensch herkam:
 * Wer in der allgemeinen Kontaktliste war, soll dorthin zurueck und nicht zu
 * einem Kunden, den er nie offen hatte. `contact.customer_id` taugt deshalb
 * nicht als Rueckweg — die Herkunft steht in der Adresse.
 *
 * Als Suchparameter `?customer_id=…` bzw. `?partner_id=…`, also auf demselben
 * Weg, auf dem „Kontakt anlegen" und „Aufgabe anlegen" ihren Bezug schon
 * immer uebergeben (`/contacts/new?customer_id=…`). Kein zweiter Mechanismus.
 *
 * Die Kette ist dreigliedrig — Kundenseite → Kontaktseite → Formular. Jedes
 * Glied gibt die Herkunft weiter; laesst eines sie fallen, reisst sie beim
 * naechsten Klick ab. Genau das war der Fehler: Das Formular kannte die
 * Herkunft nur beim Anlegen, und nach dem Bearbeiten stand man in der
 * allgemeinen Kontaktliste statt beim Kunden.
 */
export interface Herkunft {
  customerId?: string | null;
  partnerId?: string | null;
}

/** Herkunft aus den Suchparametern der Adresse. */
export function herkunftAus(params: URLSearchParams): Herkunft {
  return {
    customerId: params.get('customer_id'),
    partnerId: params.get('partner_id'),
  };
}

/**
 * Pfad mit der Herkunft als Suchparameter; ohne Herkunft unveraendert.
 * Kunde schlaegt Partner, wie bisher schon beim Anlegen eines Kontakts.
 */
export function mitHerkunft(pfad: string, herkunft: Herkunft): string {
  if (herkunft.customerId) return `${pfad}?customer_id=${encodeURIComponent(herkunft.customerId)}`;
  if (herkunft.partnerId) return `${pfad}?partner_id=${encodeURIComponent(herkunft.partnerId)}`;
  return pfad;
}

/** Rueckweg zur Herkunft samt Beschriftung, oder `null`, wenn keine bekannt ist. */
export function herkunftRueckweg(herkunft: Herkunft): { to: string; label: string } | null {
  if (herkunft.customerId) return { to: `/customers/${herkunft.customerId}`, label: 'Zum Kunden' };
  if (herkunft.partnerId) return { to: `/partners/${herkunft.partnerId}`, label: 'Zum Partner' };
  return null;
}
